// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__rHa_R","content":"index_content__fD_F2"};